export const light_theme = {
    background_primary: '#FFF',
    background_secondary: '#eeeeee',
    background_tertiary: '#fff',
    color_primary: '#363537',
    color_secondary: '#eb158c',
    color_secondary_alpha: 'rgba(235, 21, 140, 0.1)',
    color_white: '#fff',
    divider: '#bdbdbd',
}
export const dark_theme = {
    background_primary: '#363537',
    background_secondary: '#424242',
    color_secondary_alpha: 'rgba(235, 21, 140, 0.3)',
    background_tertiary: '#4c4a4e',
    color_primary: '#FAFAFA',
    color_secondary: '#f155aa',
    color_white: '#fff',
    divider: '#e0e0e0',
}
